import React from 'react';
import { useReactToPrint } from 'react-to-print';
type Props = {
  customerContent: () => React.ReactInstance | null;
  staffContent: () => React.ReactInstance | null;
  ownerContent: () => React.ReactInstance | null;
};
const usePrintOwnerReceiptWithStaff = ({ ownerContent, staffContent }: Props) => {

  const doPrintStaffReceipt = useReactToPrint({
    content: () => staffContent(),
  });

  const doPrintOwnerReceipt = useReactToPrint({
    content: () => ownerContent(),
    onAfterPrint: () => doPrintStaffReceipt(),
  });

  return doPrintOwnerReceipt;
};

export default usePrintOwnerReceiptWithStaff;
